<template>
  <v-card class="mx-auto" width="880px" elevation="6">
    <v-card-title class="display-1"
      >PLANTILLA <v-spacer></v-spacer>
      <p class="subtitle-1" v-if="true">
        Ver los códigos de área:
        <a
          href="https://www.cuandoenelmundo.com/herramientas/codigos-para-llamadas-internacionales"
          target="_blank"
          rel="noopener noreferrer"
          >Aquí</a
        >
      </p></v-card-title
    >
    <v-container class="pa-3">
      <v-row justify="center" align="center">
        <v-col cols="4" class="ma-0 pa-0">
          <v-text-field
            v-model="numeroAsistencia"
            label="NUMERO DE ASISTENCIA"
            @keyup.enter="buscarNumeroAsistencia()"
            hide-details
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="fecha"
            hide-details
            label="FECHA"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="cuenta"
            hide-details
            label="CUENTA"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="conductor"
            hide-details
            label="CONDUCTOR"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="asegurado"
            hide-details
            label="ASEGURADO"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="poliza"
            hide-details
            label="POLIZA"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="placa"
            hide-details
            label="PLACA"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="marca"
            hide-details
            label="MARCA"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="modelo"
            hide-details
            label="MODELO"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="color"
            hide-details
            label="COLOR"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="año" hide-details label="AÑO"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="uso" hide-details label="USO"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="tipoAsistencia"
            label="TIPO DE ASISTENCIA"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="depaSiniestro"
            hide-details
            label="DEPARTAMENTO"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="muniSiniestro"
            hide-details
            label="MUNICIPIO"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-textarea
            row-height="1"
            auto-grow
            v-model="direccion"
            hide-details
            label="DIRECCIÓN"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="tecnicoAsignado"
            label="TÉCNICO ASIGNADO"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-textarea
            row-height="1"
            auto-grow
            v-model="dirDestino"
            hide-details
            label="DIRECCIÓN DESTINO"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="causa"
            hide-details
            label="CAUSA"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="agente"
            hide-details
            label="AGENTE"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="observaciones"
            class="mt-0"
            hide-details
            label="OBSERVACIONES"
            outlined
          >
          </v-textarea>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            v-model="movilidad"
            class="mt-0"
            hide-details
            label="MOVILIDAD"
          ></v-checkbox>
        </v-col>
        <v-col cols="10">
          <v-checkbox
            v-model="rapiAssa"
            class="mt-0"
            hide-details
            label="RAPIASSA SEGÚN APLICATIVO"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="proveedor_seleccionado"
            :items="list_activeDrivers"
            item-text="name"
            item-value="key"
            label="Proveedores activos"
            hide-details
            solo
            rounded
            dense
            clearable
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar" :timeout="timeout" color="success">
        {{ text }}
      </v-snackbar>
      <v-snackbar
        v-model="snackbarError"
        :timeout="timeoutError"
        color="error"
        top
      >
        {{ this.errorPlaca }}</v-snackbar
      >
    </v-container>

    <!-- Botones para enviar mensaje -->
    <v-card id="create">
      <v-speed-dial
        v-model="fab"
        bottom
        right
        :direction="direction"
        :transition="transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="green darken-2" dark fab>
            <v-icon v-if="fab" class="fas fa-times"></v-icon>
            <v-icon v-else class="fas fa-inbox"></v-icon>
          </v-btn>
        </template>
        <v-btn dark small color="green" @click="doCopy()"
          >Copiar Datos <i class="far fa-copy fa-2x ml-1"></i>
        </v-btn>
        <v-btn dark small color="green" @click="MensajeProveedor()">
          Enviar al proveedor <i class="fab fa-whatsapp fa-2x ml-1"></i>
        </v-btn>
        <v-btn dark small color="green" @click="MensajeSMSClinete()">
          Enviar al afiliado <i class="fab fa-whatsapp fa-2x ml-1"></i>
        </v-btn>
        <v-btn dark small color="green" @click="crearLinkCoordenadas()">
          Link coordenadas
          <i class="fas fa-search-location fa-2x ml-1"></i>
        </v-btn>
        <v-btn
          dark
          small
          color="green"
          @click="notificacionTelegram()"
          v-if="false"
        >
          Telegram <i class="fas fa-mobile-alt fa-2x"></i
        ></v-btn>
      </v-speed-dial>
    </v-card>

    <!-- Espacio para enviar datos al proveedor -->
    <v-bottom-sheet v-model="sheetProveedor">
      <v-sheet class="text-center" height="auto">
        <p class="py-3 mb-0 title">Los datos a enviar al proveedor son:</p>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12" md="1">
              <v-text-field
                label="CODIGO"
                hint="ejemplo: 503"
                persistent-hint
                v-model="codigoSMS"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="TELEFONO"
                hint="Sin separadores"
                persistent-hint
                v-model="telefonoSMSProveedor"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-textarea
                solo
                auto-grow
                rows="1"
                label="DATOS"
                v-model="DatosProveedor"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="1" align-self="center">
              <v-btn
                color="success"
                target="_blanck"
                :href="
                  this.urlWhatsapp +
                  this.codigoSMS +
                  this.telefonoSMSProveedor +
                  '&text=' +
                  encodeURIComponent(this.DatosProveedor)
                "
                >Enviar
              </v-btn>
            </v-col>
            <v-col cols="12" md="2" align-self="center" v-if="false">
              <v-badge overlap color="deep-purple accent-4" content="6">
                <v-btn color="green" outlined text @click="mensajeWa()">
                  WhatsApp (Beta)
                  <v-icon right small color="yellow">fa-regular fa-star</v-icon>
                </v-btn>
              </v-badge>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!--Espacio para enviar datos al cliente -->
    <v-bottom-sheet v-model="sheetCliente">
      <v-sheet class="text-center" height="auto">
        <p class="py-3 mb-0 title">Los datos a enviar al cliente son:</p>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12" md="1">
              <v-text-field
                label="CODIGO"
                hint="ejemplo: +503"
                persistent-hint
                v-model="codigoSMS"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="TELEFONO"
                hint="Sin separadores"
                persistent-hint
                v-model="telefonoSMSCliente"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-textarea
                solo
                auto-grow
                rows="1"
                label="DATOS"
                v-model="DatosCliente"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn
                class="mt-6"
                color="success"
                target="_blanck"
                :href="
                  this.urlWhatsapp +
                  this.codigoSMS +
                  this.telefonoSMSCliente +
                  '&text=' +
                  encodeURIComponent(this.DatosCliente)
                "
              >
                Enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!--Espacio para enviar link de coordenadas -->
    <v-bottom-sheet v-model="sheetCoordenadas">
      <v-sheet class="text-center" height="auto">
        <p class="py-3 mb-0 title">Los datos a enviar al cliente son:</p>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12" md="1">
              <v-text-field
                label="CODIGO"
                hint="ejemplo: +503"
                persistent-hint
                v-model="codigoSMS"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="TELEFONO"
                hint="Sin separadores"
                persistent-hint
                v-model="telefonoSMSCliente"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-textarea
                solo
                auto-grow
                rows="1"
                label="DATOS"
                v-model="DatosCliente"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn
                class="mt-6"
                color="success"
                target="_blanck"
                :href="
                  this.urlWhatsapp +
                  this.codigoSMS +
                  this.telefonoSMSCliente +
                  '&text=' +
                  encodeURIComponent(this.DatosCliente)
                "
              >
                Enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-card>
</template>

<script>
import axios from "axios";

import {
  dbRefProveedor,
  geofireRef,
  messaging,
  dbRefAsistencias,
  dbRefToken,
  dbCoordenadas,
} from "../main";

export default {
  data() {
    return {
      detalles: [],
      list_activeDrivers: [],
      idCabina: "",
      proveedor_seleccionado: null,
      numeroAsistencia: "",
      numeroAsistenciaEncrypt: "",
      fecha: "",
      cuenta: "",
      conductor: "",
      asegurado: "",
      poliza: "",
      placa: "",
      marca: "",
      modelo: "",
      color: "",
      uso: "",
      año: "",
      depaSiniestro: "",
      muniSiniestro: "",
      direccion: "",
      tipoAsistencia: "",
      tecnicoAsignado: "",
      causa: "",
      agente: "",
      observaciones: "",
      movilidad: "",
      rapiAssa: "",
      dirDestino: "",
      errorPlaca: null,
      message: "",
      snackbar: false,
      snackbarError: false,
      text: "TEXTO COPIADO",
      timeout: 1000,
      timeoutError: 6000,
      sheetProveedor: false,
      sheetCliente: false,
      sheetCoordenadas: false,
      codigoSMS: "",
      telefonoSMSProveedor: "",
      telefonoSMSCliente: "",
      DatosProveedor: "",
      DatosCliente: "",
      urlWhatsapp: "https://api.whatsapp.com/send?phone=",
      direction: "top",
      fab: false,
      hover: false,
      tabs: null,
      right: true,
      bottom: true,
      transition: "scale-transition",
      markers: [
        {
          key: "",
          name: "",
          plate: "",
          position: {
            lat: 0,
            lng: 0,
          },
        },
      ],
      nameDriver: null,
      namePlate: null,
      code: "",
      URLMapa: "",
      urlCoordenadas: "",
      toString: [],
      toStringSeleccionados: [],
      toStringTokens: [],
      token: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
      chatId: -799958226,
    };
  },
  created() {
    this.initGeoFire();
    this.tokenMensaje();
  },
  methods: {
    mensajeWa() {
      axios
        .post("api/WhatsAppApiContactos/Crear", {
          id_usuario: this.$store.state.usuario.idUsuario,
          template_bd: this.DatosProveedor,
          nombre_contacto: "",
          numero_contacto: this.codigoSMS + this.telefonoSMSProveedor,
          messaging_product: "whatsapp",
          to: this.codigoSMS + this.telefonoSMSProveedor,
          type: "template",
          template: {
            name: "notificacion_proveedor",
            language: {
              code: "es",
            },
            components: [
              {
                type: "body",
                parameters: [
                  {
                    type: "text",
                    text: this.numeroAsistencia ? this.numeroAsistencia : "SD",
                  },
                  {
                    type: "text",
                    text: this.fecha ? this.fecha : "SD",
                  },
                  {
                    type: "text",
                    text: this.cuenta ? this.cuenta : "SD",
                  },
                  {
                    type: "text",
                    text: this.conductor ? this.conductor : "SD",
                  },
                  {
                    type: "text",
                    text: this.asegurado ? this.asegurado : "SD",
                  },
                  {
                    type: "text",
                    text: this.poliza ? this.poliza : "SD",
                  },
                  {
                    type: "text",
                    text: this.placa ? this.placa : "SD",
                  },
                  {
                    type: "text",
                    text: this.marca ? this.marca : "SD",
                  },
                  {
                    type: "text",
                    text: this.modelo ? this.modelo : "SD",
                  },
                  {
                    type: "text",
                    text: this.color ? this.color : "SD",
                  },
                  {
                    type: "text",
                    text: this.uso ? this.uso : "SD",
                  },
                  {
                    type: "text",
                    text: this.año ? this.año : "SD",
                  },
                  {
                    type: "text",
                    text: this.depaSiniestro ? this.depaSiniestro : "SD",
                  },
                  {
                    type: "text",
                    text: this.muniSiniestro ? this.muniSiniestro : "SD",
                  },
                  {
                    type: "text",
                    text: this.direccion ? this.direccion : "SD",
                  },
                  {
                    type: "text",
                    text: this.dirDestino ? this.dirDestino : "SD",
                  },
                  {
                    type: "text",
                    text: this.tipoAsistencia ? this.tipoAsistencia : "SD",
                  },
                  {
                    type: "text",
                    text: this.tecnicoAsignado ? this.tecnicoAsignado : "SD",
                  },
                  {
                    type: "text",
                    text: this.causa ? this.causa : "SD",
                  },
                  {
                    type: "text",
                    text: this.observaciones
                      ? this.observaciones.replace(/\n|\r/g, ", ")
                      : "SD",
                  },
                  {
                    type: "text",
                    text: this.agente ? this.agente : "SD",
                  },
                  {
                    type: "text",
                    text: this.movilidad ? this.movilidad : "SD",
                  },
                  {
                    type: "text",
                    text: this.rapiAssa ? this.rapiAssa : "SD",
                  },
                ],
              },
            ],
          },
        })
        .then((response) => {
          //console.log("RESPONSE ", response.data);
          if (response.data.error) {
            return this.alertaError(
              "Mensaje no se pudo enviar motivo: " + response.data.error.message
            );
          }
          if (
            response.data.messaging_product == "whatsapp" &&
            response.data.messages[0].message_status == "accepted"
          ) {
            return this.alertaCorrecto(
              "Mensaje enviado correctamente: Para dar seguimiento ir a modulo de WhatsApp"
            );
          }
        });
    },
    tokenMensaje() {
      messaging.requestPermission().then(function () {
        messaging
          .getToken({
            vapidKey:
              "BCqcGUs7xd5xhCmuDZq3vx0o_Ea-M3RptaFythzPOJfXgBK4l3cwyMzg3d2KmLnuBdP1DejSSLA5UdaA-fuXslA",
          })
          .then(function (currentToken) {});
      });

      messaging.onMessage(function (message) {});
    },
    obtenerProveedoresActivos() {
      let me = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
          var query = geofireRef.query({
            center: [lat, lng],
            radius: 170,
          });
          query.on("key_entered", function (key, location, distance) {
            me.toString.push(key);
          });
          me.verDetallesProveedor();
        });
      }
    },
    verDetallesProveedor() {
      let me = this;
      var splitTipoAsistencia = "";
      for (var i = 0; i < me.toString.length; i++) {
        dbRefProveedor.child(me.toString[i]).on("value", function (snapShop) {
          splitTipoAsistencia = snapShop.val().typeAssistance.split(",");
          for (var j = 0; j < splitTipoAsistencia.length; j++) {
            switch (splitTipoAsistencia[j]) {
              case "Grúa":
                if (me.tipoAsistencia == "GRUA") {
                  me.toStringSeleccionados.push(snapShop.key);
                }
                break;
              case "Inspeccion":
                if (me.tipoAsistencia == "AJUSTE") {
                  me.toStringSeleccionados.push(snapShop.key);
                }
                break;
              case "Cambio de llanta":
                if (me.tipoAsistencia == "CAMBIO DE LLANTA") {
                  me.toStringSeleccionados.push(snapShop.key);
                }
                break;
              case "Paso de corriente":
                if (me.tipoAsistencia == "PASO DE CORRIENTE") {
                  me.toStringSeleccionados.push(snapShop.key);
                }
                break;
              case "Cerrajeria":
                if (me.tipoAsistencia == "CERRAJERIA") {
                  me.toStringSeleccionados.push(snapShop.key);
                }
                break;
              case "Hogar":
                if (
                  me.tipoAsistencia == "CERRAJERIA HOGAR" ||
                  me.tipoAsistencia == "ELECTRICIDAD HOGAR" ||
                  me.tipoAsistencia == "FONTANERIA HOGAR"
                ) {
                  me.toStringSeleccionados.push(snapShop.key);
                }
                break;
              case "Abasto combustible":
                if (me.tipoAsistencia == "ABASTO DE COMBUSTIBLE") {
                  me.toStringSeleccionados.push(snapShop.key);
                }
                break;
            }
          }
        });
      }
      me.obtenerTokenProveedores();
    },
    obtenerTokenProveedores() {
      let me = this;
      for (var i = 0; i < me.toStringSeleccionados.length; i++) {
        dbRefToken
          .child(me.toStringSeleccionados[i])
          .on("value", function (key) {
            me.toStringTokens.push(key.val().token);
          });
      }
      me.enviarNotificacion();
    },
    enviarNotificacion() {
      let me = this;
      var key =
        "AAAAkjAYHbQ:APA91bGeAuz7m1hR2jE9fYLJym3usdVCqL9nMz4DWwz4V8F7litoBKB2cxKRQpYRS8E86YhZklZ_AX51mMjWn8TEUgCWbAwB5-R3Ifd6cOyZVtpp_TEPJAjomjY0VZhvu_I-4xwZAdeC";
      var notification = {
        title: "NOTIFICACION CABINA",
        body: "Se solicita un proveedor para asistencia",
        idCabina: me.idCabina,
        numeroAsistencia: me.numeroAsistencia,
        cuenta: me.cuenta,
        conductor: me.conductor,
        asegurado: me.asegurado,
        poliza: me.poliza,
        placa: me.placa,
        marca: me.marca,
        modelo: me.modelo,
        año: me.año,
        color: me.color,
        uso: me.uso,
        departamento: me.depaSiniestro,
        municipio: me.muniSiniestro,
        direccion: me.direccion,
        direccionDestino: me.dirDestino,
        tipoAsistencia: me.tipoAsistencia,
        causa: me.causa,
        status: "Create",
        statusColor: "#3a86ff",
      };

      dbRefAsistencias
        .child(me.numeroAsistencia)
        .set(notification)
        .then(function (response) {
          console.log("Asistencia creada");
        })
        .catch(function (error) {
          console.log("No se pudo crear la asistencia");
        });

      for (var i = 0; i < me.toStringTokens.length; i++) {
        var to = me.toStringTokens[i];

        fetch("https://fcm.googleapis.com/fcm/send", {
          method: "POST",
          headers: {
            Authorization: "key=" + key,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: notification,
            to: to,
          }),
        })
          .then(function (response) {
            console.log(response);
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    },
    buscarNumeroAsistencia() {
      let me = this;
      me.errorPlaca = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Cabinas/MostrarCodigoNumAsistencia/" + this.numeroAsistencia,
          configuracion
        )
        .then(function (response) {
          me.detalles = response.data;
          me.agregarDetalle(response.data);
          me.asignarCodigoArea(response.data);
          me.asignarTelefonoCliente(response.data);
          me.asignarTelefonoProveedor(response.data);
        })
        .catch(function (error) {
          console.log(error);
          me.errorPlaca = "No se encuentra registrado el numero de asistencia.";
          me.snackbarError = true;
          me.limpiar();
        });
    },
    agregarDetalle(data = []) {
      this.errorPlaca = null;
      (this.idCabina = data["idCabina"]),
        (this.fecha = data["fechaHoraActual"]),
        (this.cuenta = data["cartera"]),
        (this.conductor = data["nombreConductor"]),
        (this.asegurado = data["titularPoliza"]),
        (this.poliza = data["poliza"]),
        (this.placa = data["placa"]),
        (this.marca = data["marca"]),
        (this.modelo = data["modelo"]),
        (this.color = data["color"]),
        (this.año = data["año"]),
        (this.direccion = data["comDireccionSiniestro"]),
        (this.tipoAsistencia = data["tipoAsistencia"]),
        (this.tecnicoAsignado = data["proveedor"]);
      this.causa = data["causa"];
      this.dirDestino = data["comDireccionDestino"];
      this.uso = data["uso"];
      this.depaSiniestro = data["depaSiniestro"];
      this.muniSiniestro = data["muniSiniestro"];
      this.agente = data["agente"];
      this.observaciones = data["obsAdicionales"];

      if (data["protocolo"]) {
        this.movilidad = "SI";
      } else {
        this.movilidad = "NO";
      }

      if (data["checkboxRapiAssaSegunPlataforma"]) {
        this.rapiAssa = "SI";
      } else {
        this.rapiAssa = "NO";
      }
    },
    limpiar() {
      this.fecha = "";
      this.cuenta = "";
      this.conductor = "";
      this.asegurado = "";
      this.poliza = "";
      this.placa = "";
      this.marca = "";
      this.modelo = "";
      this.color = "";
      this.año = "";
      this.direccion = "";
      this.tipoAsistencia = "";
      this.tecnicoAsignado = "";
      this.causa = "";
      this.observaciones = "";
      this.codigoSMS = "";
      this.telefonoSMS = "";
      this.telefonoSMSCliente = "";
      this.dirDestino = "";
      this.uso = "";
      this.agente = "";
      this.movilidad = "";
      this.rapiAssa = "";
      this.DatosCliente = "";
      this.DatosProveedor = "";
      this.snackbar = false;
    },
    doCopy: function () {
      let me = this;
      if (
        this.tipoAsistencia == "AJUSTE" ||
        this.tipoAsistencia == "INSPECCION ON LINE"
      ) {
        this.$copyText(
          "Numero Asistencia: " +
            this.numeroAsistencia +
            "\n" +
            "Fecha: " +
            this.fecha +
            "\n" +
            "Cuenta: " +
            "*" +
            this.cuenta +
            "*" +
            "\n" +
            "Conductor: " +
            this.conductor +
            "\n" +
            "Asegurado:" +
            "*" +
            this.asegurado +
            "*" +
            "\n" +
            "Poliza: " +
            this.poliza +
            "\n" +
            "Placa: " +
            "*" +
            this.placa +
            "*" +
            "\n" +
            "Marca: " +
            this.marca +
            "\n" +
            "Modelo: " +
            this.modelo +
            "\n" +
            "Color: " +
            this.color +
            "\n" +
            "Uso: " +
            this.uso +
            "\n" +
            "Año: " +
            this.año +
            "\n" +
            "Departamento: " +
            this.depaSiniestro +
            "\n" +
            "Municipio: " +
            this.muniSiniestro +
            "\n" +
            "Dirección: " +
            this.direccion +
            "\n" +
            "Dirección Destino: " +
            this.dirDestino +
            "\n" +
            "Tipo De Asistencia: " +
            "*" +
            this.tipoAsistencia +
            "*" +
            "\n" +
            "Técnico Asignado: " +
            "*" +
            this.tecnicoAsignado +
            "*" +
            "\n" +
            "Causa: " +
            this.causa +
            "\n" +
            "Observaciones: " +
            this.observaciones +
            "\n" +
            "Agente: " +
            this.agente +
            "\n" +
            "Movilidad: " +
            this.movilidad +
            "\n" +
            "Rapiassa según aplicativo: " +
            this.rapiAssa
        ).then(
          function (e) {
            me.snackbar = true;
          },
          function (e) {
            alert("Can not copy");
          }
        );
      } else {
        this.$copyText(
          "Numero Asistencia: " +
            this.numeroAsistencia +
            "\n" +
            "Fecha: " +
            this.fecha +
            "\n" +
            "Cuenta: " +
            "*" +
            this.cuenta +
            "*" +
            "\n" +
            "Conductor: " +
            this.conductor +
            "\n" +
            "Asegurado:" +
            "*" +
            this.asegurado +
            "*" +
            "\n" +
            "Poliza: " +
            this.poliza +
            "\n" +
            "Placa: " +
            "*" +
            this.placa +
            "*" +
            "\n" +
            "Marca: " +
            this.marca +
            "\n" +
            "Modelo: " +
            this.modelo +
            "\n" +
            "Color: " +
            this.color +
            "\n" +
            "Uso: " +
            this.uso +
            "\n" +
            "Año: " +
            this.año +
            "\n" +
            "Departamento: " +
            this.depaSiniestro +
            "\n" +
            "Municipio: " +
            this.muniSiniestro +
            "\n" +
            "Dirección: " +
            this.direccion +
            "\n" +
            "Dirección Destino: " +
            this.dirDestino +
            "\n" +
            "Tipo De Asistencia: " +
            "*" +
            this.tipoAsistencia +
            "*" +
            "\n" +
            "Técnico Asignado: " +
            "*" +
            this.tecnicoAsignado +
            "*" +
            "\n" +
            "Causa: " +
            this.causa +
            "\n" +
            "Observaciones: " +
            this.observaciones +
            "\n" +
            "Movilidad: " +
            this.movilidad +
            "\n" +
            "Rapiassa según aplicativo: " +
            this.rapiAssa
        ).then(
          function (e) {
            me.snackbar = true;
          },
          function (e) {
            alert("Can not copy");
          }
        );
      }
    },
    MensajeProveedor() {
      this.sheetProveedor = true;
      //primero se debe de colocar el codigo y telefono a enviar y mostrara los datos a enviar...
      //validacion de campo agente para tipo de asistencia Ajuste o Inspeccion on line
      if (
        this.tipoAsistencia == "AJUSTE" ||
        this.tipoAsistencia == "INSPECCION ON LINE"
      ) {
        this.DatosProveedor =
          "Numero Asistencia:" +
          this.numeroAsistencia +
          "\n" +
          "Fecha:" +
          this.fecha +
          "\n" +
          "Cuenta:" +
          this.cuenta +
          "\n" +
          "Conductor: " +
          this.conductor +
          "\n" +
          "Asegurado:" +
          this.asegurado +
          "\n" +
          "Poliza: " +
          this.poliza +
          "\n" +
          "Placa: " +
          this.placa +
          "\n" +
          "Marca: " +
          this.marca +
          "\n" +
          "Modelo: " +
          this.modelo +
          "\n" +
          "Color: " +
          this.color +
          "\n" +
          "Uso: " +
          this.uso +
          "\n" +
          "Año: " +
          this.año +
          "\n" +
          "Departamento: " +
          this.depaSiniestro +
          "\n" +
          "Municipio: " +
          this.muniSiniestro +
          "\n" +
          "Dirección: " +
          this.direccion +
          "\n" +
          "Dirección Destino: " +
          this.dirDestino +
          "\n" +
          "Tipo De Asistencia: " +
          this.tipoAsistencia +
          "\n" +
          "Técnico Asignado: " +
          this.tecnicoAsignado +
          "\n" +
          "Causa: " +
          this.causa +
          "\n" +
          "Observaciones: " +
          this.observaciones +
          "\n" +
          "Agente: " +
          this.agente +
          "\n" +
          "Movilidad: " +
          this.movilidad +
          "\n" +
          "Rapiassa según aplicativo: " +
          this.rapiAssa;
      } else {
        this.DatosProveedor =
          "Numero Asistencia:" +
          this.numeroAsistencia +
          "\n" +
          "Fecha:" +
          this.fecha +
          "\n" +
          "Cuenta:" +
          this.cuenta +
          "\n" +
          "Conductor: " +
          this.conductor +
          "\n" +
          "Asegurado:" +
          this.asegurado +
          "\n" +
          "Poliza: " +
          this.poliza +
          "\n" +
          "Placa: " +
          this.placa +
          "\n" +
          "Marca: " +
          this.marca +
          "\n" +
          "Modelo: " +
          this.modelo +
          "\n" +
          "Color: " +
          this.color +
          "\n" +
          "Uso: " +
          this.uso +
          "\n" +
          "Año: " +
          this.año +
          "\n" +
          "Departamento: " +
          this.depaSiniestro +
          "\n" +
          "Municipio: " +
          this.muniSiniestro +
          "\n" +
          "Dirección: " +
          this.direccion +
          "\n" +
          "Dirección Destino: " +
          this.dirDestino +
          "\n" +
          "Tipo De Asistencia: " +
          this.tipoAsistencia +
          "\n" +
          "Técnico Asignado: " +
          this.tecnicoAsignado +
          "\n" +
          "Causa: " +
          this.causa +
          "\n" +
          "Observaciones: " +
          this.observaciones +
          "\n" +
          "Movilidad: " +
          this.movilidad +
          "\n" +
          "Rapiassa según aplicativo: " +
          this.rapiAssa;
      }
    },
    MensajeSMSClinete() {
      if (this.proveedor_seleccionado == null) {
        this.URLMapa = "";
      } else {
        this.codeRandom();
      }
      this.sheetCliente = true;
      //primero se debe de colocar el codigo y telefono a enviar y mostrara los datos a enviar...
      this.DatosCliente =
        "Estimado(a):" +
        "\n" +
        "Se le notifica que su servicio de " +
        this.tipoAsistencia +
        ", bajo la póliza " +
        this.poliza +
        ", será atendido por " +
        this.tecnicoAsignado +
        "\n" +
        "Estamos atentos a su servicio" +
        "\n" +
        this.URLMapa;
    },
    asignarCodigoArea(data) {
      switch (data.pais) {
        case "EL SALVADOR":
          this.codigoSMS = "503";
          break;
        case "GUATEMALA":
          this.codigoSMS = "502";
          break;
        case "HONDURAS":
          this.codigoSMS = "504";
          break;
        case "NICARAGUA":
          this.codigoSMS = "503";
          break;
        case "COSTA RICA":
          this.codigoSMS = "505";
          break;
        case "PANAMÁ":
          this.codigoSMS = "507";
          break;
        case "BELICE":
          this.codigoSMS = "501";
          break;
        case "MÉXICO":
          this.codigoSMS = "52";
          break;
      }
    },
    asignarTelefonoCliente(data) {
      this.telefonoSMSCliente = data.numeroTelefono;
    },
    asignarTelefonoProveedor(data) {
      this.telefonoSMSProveedor = data.telefonoProveedor;
    },
    prototipoParaEnviarPorSMS() {
      /*
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.sheetProveedor = false;
      var codigo = me.codigoSMS;
      var telefono = me.telefonoSMS;
      var mensaje = me.DatosProveedor;
      axios
        .get(
          "api/Cabinas/SMSPhone/" + codigo + "/" + telefono + "/" + mensaje,
          configuracion
        )
        .then(function(response) {
          console.log(response);
        }).catch(function(error){
          me.errorPlaca = "Sucedio algun error al enviar el mensaje al proveedor.";
          me.snackbarError = true;
        });
        */
    },
    initGeoFire() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
          var query = geofireRef.query({
            center: [lat, lng],
            radius: 170,
          });

          query.on("key_entered", (key, location, distance) => {
            const dataName = dbRefProveedor.child(key);

            dataName.on("value", (snapshot) => {
              this.nameDriver = snapshot.val().name;
              this.namePlate = snapshot.val().vehiclePlate;
              this.markers.push({
                key: key,
                name: this.nameDriver,
                plate: this.namePlate,
                position: {
                  lat: location[0],
                  lng: location[1],
                },
              });
              this.list_activeDrivers.push({
                key: key,
                name: this.nameDriver,
              });
            });
          });

          query.on("key_exited", (key, location, distance) => {
            for (var i = 0; i < this.markers.length; i++) {
              if (this.markers[i].key == key) {
                this.markers.splice(i, 1);
              }
            }
          });

          query.on("key_moved", (key, location, distance) => {
            for (var i = 0; i < this.markers.length; i++) {
              if (this.markers[i].key == key) {
                var updatePosition = {
                  lat: location[0],
                  lng: location[1],
                };
                this.markers[i].position = updatePosition;
              }
            }
          });
        });
      }
    },
    codeRandom() {
      var code = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 5; i++) {
        code += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      this.generarURL(code);
    },
    generarURL(code) {
      //la url para enviar al cliente
      dbRefProveedor
        .child(this.proveedor_seleccionado + "/" + "code")
        .set(code);
      if (this.cuenta == "ASSA COMPAÑIA DE SEGUROS") {
        this.URLMapa =
          "Si desea monitorear a su proveedor dar clic al siguiente link: " +
          "\n" +
          "https://asistenciaregional.net/" +
          "seguimientoAssa/" +
          this.proveedor_seleccionado +
          "~" +
          code;
      } else {
        this.URLMapa =
          "Si desea monitorear a su proveedor dar clic al siguiente link: " +
          "\n" +
          "https://asistenciaregional.net/" +
          "seguimiento/" +
          this.proveedor_seleccionado +
          "~" +
          code;
      }
    },
    crearLinkCoordenadas() {
      dbCoordenadas.child(this.numeroAsistencia).set({
        latitude: 0,
        longitude: 0,
      });
      this.urlCoordenadas =
        "https://asistenciaregional.net/MapaCoordenadas/" +
        this.numeroAsistencia;
      this.mensajeSMSCoordenadas();
    },
    mensajeSMSCoordenadas() {
      this.sheetCoordenadas = true;
      //primero se debe de colocar el codigo y telefono a enviar y mostrara los datos a enviar...
      this.DatosCliente =
        "Estimado(a):" +
        "\n" +
        "Este es un link para que pueda enviarnos su dirección " +
        "\n" +
        this.urlCoordenadas;
    },
    notificacionTelegram() {
      axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatId +
            "&text=Mensaje de prueba desde el sistema. :)"
        )
        .then((response) => {
          console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    alertaError(mensaje) {
      this.$toast.error(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 10000,
      });
    },
    alertaCorrecto(mensaje) {
      this.$toast.success(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 10000,
      });
    },
  },
};
</script>

<style scoped>
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
#create {
  border: 0px;
}
</style>
